// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0766d07e","384":"32136a06","700":"8dff5532","703":"38afca75"}[chunkId] + ".chunk.js";
};